module.exports = __webpack_public_path__ + "img/W-G40.fe94e0cd.jpg";